/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';
import Lottie from "lottie-react";
import funnelSpot from './Funnel_Spot_NoLoop_01.json';

const FunnelSpot = (props) => {
    return (
        <Lottie animationData={JSON.parse(JSON.stringify(funnelSpot))} {...props}/>
    );
}

export default FunnelSpot;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/animations/funnelSpot/funnelSpot.jsx